<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

    Table wrapper

------------------------------->
@let isExpanded = checkExpansion();
<sb-table-wrapper-new
  headline="{{'nav.templateEntries' | translate}}"
  [itemsData]="renderedTemplates"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'templateEntries'">

  <!------------------------------

Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >
      <div
        #filterPanelTimeRange
        class="tw-flex tw-flex-row tw-mx-3 tw-font-semibold tw-items-center tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-group tw-w-fit "
        [ngClass]="{'tw-cursor-pointer': !isExpanded}"
        (click)="!isExpanded?openFilterPanel(filterPanelTimeRange):scrollToFilterPanelElement(filterPanelTimeRange)">
        <sb-icon class="tw-text-xl" [ngClass]="{'tw-ml-2.5': !isExpanded}" icon="calendar"></sb-icon>
        <div class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left tw-text-lg tw-flex-1"
             [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.globals.timeRange' | translate }}
        </div>
      </div>

      @if (isExpanded) {
        <sb-local-date-range-input
          class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left tw-mx-3"
          [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-auto': isExpanded,
    }"
          [from]="from" [till]="till" [displayMonths]="1" [showSubmit]="true" [today]="null" [allowEmpty]="true"
          (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
      }
    </sb-filter-panel>
  </div>


  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th>ID</th>
      <th>Status</th>
      <th>Identifier</th>
      <th>Name</th>
      <th>Template-Name</th>
      <th>Valid-From</th>
      <th>Valid-Till</th>
      @for (variable of group.variables; track variable.name) {
        <th>
          Var: {{ variable.name }}
        </th>
      }
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-entry>

    <tr>
      <td style="padding-left: 1.8rem!important;">{{ entry?.id }}</td>
      <td>
        <div [ngbTooltip]="entry.rejected ? rejected : null" [tooltipContext]="{entry: entry}" container="body">

          @if (entry.rejected) {
            <sb-icon icon="error" class="red"></sb-icon>
          } @else {
            <sb-icon icon="success" class="green"></sb-icon>
          }
        </div>
      </td>
      <td>{{ entry?.identifier }}</td>
      <td>{{ entry?.name }}</td>
      <td>{{ entry?.dataSetEntry?.dataSet?.name }}</td>
      <td>{{ entry?.dataSetEntry?.validFrom | date: 'dd.MM.yy HH:mm' }}</td>
      <td>{{ entry?.dataSetEntry?.validTill | date: 'dd.MM.yy HH:mm' }}</td>
      @for (variable of group.variables; track variable.name) {
        <td>
          @if (entry?.values[variable.name]) {
            <ng-container>
              @if (variable.type === TemplateVariableType.TEXT) {
                <div>
                  <span [innerHTML]="entry?.values[variable.name] | truncate: 100"></span>
                </div>
              } @else if (variable.type === TemplateVariableType.IMAGE) {
                <div>
                  <img class="symbol-label" [src]="entry?.values[variable.name]" alt="{{variable.name}}">
                </div>
              }
            </ng-container>
          } @else {
            <ng-template>
              <span style="font-style: italic; opacity: 0.3">n. def.</span>
            </ng-template>
          }
        </td>
      }
      <td class="tr bw sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="entry.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(entry, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>


<ng-template #rejected let-entry="entry">
  <div>

    <ul>
      <li class="tw-flex-nowrap">{{ 'lang.globals.rejected' | translate }}
        : {{ entry?.rejectedAt?.toString() | date : 'dd.MM.yyyy HH:mm' }}
      </li>
      <li class="tw-flex-nowrap">{{ 'lang.verification.rejectedByUser' | translate : { user: entry?.rejectedBy?.name } }}</li>
    </ul>
  </div>
</ng-template>
